import { connect } from 'react-redux'
import * as actions from './actions'
import Contacts from './Contacts'

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingList: state.contacts.isFetchingList,
    contacts: state.contacts.contacts,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  fetchContactList: token => dispatch(actions.fetchContactList(token)),
  createContactList: (token, name) =>
    dispatch(actions.createContactList(token, name))
})

const ContactsContainer = connect(mapStateToProps, mapDispatchToProps)(
  Contacts
)

export default ContactsContainer



// WEBPACK FOOTER //
// ./src/routes/Contacts/ContactsContainer.js